import React,{useState} from "react";
import uploadIcon from "../../assets/images/icons/upload.png";
import { toast } from "react-toastify";
import { uploadBanner } from "../../api/uploadMedia";


const UploadedBanner = ({ defaultImage, prama, uploadimage }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (event) => {
    // Access prama directly from props instead of local state
    const { categoryIndex, exerciseIndex } = prama;
    
    // console.log("categoryIndex, exerciseIndex", categoryIndex, exerciseIndex);
      //  uploadimage(
      //   categoryIndex,
      //   exerciseIndex,
      //   true,
      //   'https://du3giq2b1hx2d.cloudfront.net/banners/526x526_11.jpg/526x526_11.jpg'
      // );

    
   const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 83886080) {
        setError("File size must be less than 80 MB.");
      } else {

        // event.preventDefault();

        try {
          setLoading(true);
          const response = await uploadBanner(selectedFile, selectedFile.name);
          if (response.status === 201) {
            uploadimage( categoryIndex,exerciseIndex,true,response.data.url)

            // setDialogShow(true);
            toast.success("Your banner was uploaded successfully!", {
              position: "top-center",
              autoClose: 5000,
            });
          } else {
            setError("Something went wrong! Please try again later");
          }
        } catch (error) {
          console.error(
            "Error:",
            error.response ? error.response.data : error.message
          );
          setError("There was an error uploading the banner.");
        } finally {
          setLoading(false);
        }

      }
    }

  };

  return (
    <div className="mb-3">
      <label htmlFor="Category" className="form-label">
        Banner
      </label>
      <div className="file-upload">
        {defaultImage ? (
          <img
            src={defaultImage}
            alt="Uploaded Banner"
            className="img-fluid"
            loading="lazy"
            onClick={() => document.getElementById(`bannerFileInput-${prama.categoryIndex}-${prama.exerciseIndex}`).click()}
          />
        ) : (
          <section onClick={() => document.getElementById(`bannerFileInput-${prama.categoryIndex}-${prama.exerciseIndex}`).click()}>
            <img
              src={uploadIcon}
              alt="Upload Icon"
              loading="lazy"
            />
            <span>Upload Banner</span>
          </section>
        )}
        <form className="text-center">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            required
            className="d-none"
            id={`bannerFileInput-${prama.categoryIndex}-${prama.exerciseIndex}`}
          />
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {loading && (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          )}
        </form>
      </div>
    </div>
  );
};

export default UploadedBanner;